const state = {
    isOpen : false
}

const getters = {
    isOpen :(state) => state.isOpen
}

const actions = {
    cpmSetIsOpen({commit}, boolean_value) {
        commit('cpmSetIsOpen', boolean_value);
    }
}

const mutations = {
    cpmSetIsOpen(state, boolean_value) {
        state.isOpen = boolean_value;
    }
}

export default {
    namespaced : true,
    state,
    getters,
    actions,
    mutations
}